var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers } from "redux";
import { dataReducer } from "./dataReducer";
import { globalReducer } from "./globalReducer";
import { fileReducer } from "./fileReducer";
import { controlReducer } from "./controlReducer";
import { timer } from "../components/util/util";
export var rootReducer = combineReducers({
    global: globalReducer,
    data: dataReducer,
    file: fileReducer,
    control: controlReducer,
});
function crossSliceReducer(state, action) {
    // console.log(`--------reducer--------`, action.type, `---------------`, action.payload)
    var payload = action.payload;
    switch (action.type) {
        case "backHomePage":
            timer.destory();
            return __assign(__assign({}, state), { data: dataReducer(state.data, { type: "init", payload: "init" }), control: controlReducer(state.control, {
                    type: "changeControl",
                    payload: {
                        activeView: "homepage",
                    },
                }) });
        case "startExtract":
            return __assign(__assign({}, state), { data: dataReducer(state.data, {
                    type: "changeExtractData",
                    payload: __assign(__assign({}, payload.data), { loadingProgress: "文档信息提取中，请稍候......" }),
                }), control: controlReducer(state.control, {
                    type: "changeControl",
                    payload: payload.control,
                }) });
        case "showTask":
            return __assign(__assign({}, state), { data: dataReducer(state.data, {
                    type: "changeExtractData",
                    payload: payload.data,
                }), control: controlReducer(state.control, {
                    type: "changeControl",
                    payload: payload.control,
                }) });
        case "showSuccessfulResult":
            return __assign(__assign({}, state), { data: dataReducer(state.data, {
                    type: "changeExtractData",
                    payload: payload.data,
                }), control: controlReducer(state.control, {
                    type: "changeControl",
                    payload: payload.control,
                }) });
        case "showErrorResult":
            return __assign(__assign({}, state), { data: dataReducer(state.data, {
                    type: "changeExtractData",
                    payload: payload.data,
                }), control: controlReducer(state.control, {
                    type: "changeControl",
                    payload: payload.control,
                }) });
        case "invokePolling":
            if (state.data.extract.taskId) {
                if (payload === state.data.extract.taskId) {
                    timer.invokePolling(function () {
                        return state.global.model.invokeAsync("polling", {
                            taskId: state.data.extract.taskId,
                            createTime: "".concat(new Date().getTime()),
                        });
                    });
                }
                else {
                    if (timer.timeOut) {
                        state.global.model.invokeAsync("resultData", {
                            code: "0",
                            message: "taskId校验失败",
                        });
                        console.error("taskId校验失败");
                    }
                }
            }
            return __assign({}, state);
        default:
            return state;
    }
}
export var baseReducer = function (state, action) {
    var intermediateState = rootReducer(state, action);
    return crossSliceReducer(intermediateState, action);
};
